import styled from "styled-components";
import SegmentedControl from "../SegmentedControl/SegmentedControl";
import { pxToRem } from "../../styles/utils";

export const ToggleSwitchContainer = styled(SegmentedControl)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: none;
  margin-bottom: ${pxToRem(24)};
  padding: ${pxToRem(4)};
  overflow: visible;
  border: none;
  border-radius: ${pxToRem(15)};
  background: ${({ theme }) => theme.colors.canvas};

  button {
    height: auto;
    flex: 1 1 0;
    padding: ${pxToRem(8)} ${pxToRem(16)};
    border: none;
    border-radius: ${pxToRem(13)};
    background: transparent;
    color: ${({ theme }) => theme.colors.grayCool};
    font-size: ${pxToRem(14)};
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s, color 0.2s;
  }

  button[aria-pressed="true"] {
    background: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.white};
  }

  button:not([aria-pressed="true"]):hover:not(:disabled) {
    background: transparent;
    color: ${({ theme }) => theme.colors.brand};
  }

  button[aria-pressed="true"]:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.brand};
    color: ${({ theme }) => theme.colors.white};
  }
`;
